var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEnter56 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 56,
  height: 56,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M15.5 10a.5.5 0 0 0 0 1h31a3.5 3.5 0 0 1 3.5 3.5v18a3.5 3.5 0 0 1-3.5 3.5H8.707l9.147-9.146a.5.5 0 0 0-.708-.708l-10 10a.499.499 0 0 0 0 .708l10 10a.5.5 0 0 0 .708-.708L8.707 37H46.5a4.5 4.5 0 0 0 4.5-4.5v-18a4.5 4.5 0 0 0-4.5-4.5h-31Z",
  clipRule: "evenodd"
})));
export { SvgEnter56 as ReactComponent };
export default __webpack_public_path__ + "e4ed0495107fcc67411794ba651411b9.svg";